import { ActionReducerMap } from '@ngrx/store';
import { RpaBluePrismReducers } from '../blue-prism/store/reducers/rpa-bluprism-conn.reducers';
import { RpaUIPathReducers } from '../uipath/store/reducers/rpa-uipath-conn.reducers';
import { RpaUIPathDashboardReducers } from '../uipath/store/reducers/rpa-uipath-dashboard.reducers';
import { RpaAutomationAnywhereReducers } from '../automation-anywhere/store/reducers/rpa-automation-anywhere-conn.reducers';
import { IRPAGlobalState } from './IRpaBots';

export const RPA_GLOBAL_REDUCER: ActionReducerMap<IRPAGlobalState> = {
    uiPathConnectors: RpaUIPathReducers,
    uiPathDashboard:  RpaUIPathDashboardReducers,
    bluePrismConnectors: RpaBluePrismReducers,
    automationAnywhere: RpaAutomationAnywhereReducers
};
